import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ['displayModal']
  static values = {
    tableId: String,
  }
  connect(){
    this.table = document.getElementById(this.tableIdValue);
    this.hiddenIndexes = new Set();
    document.querySelectorAll('.dropdown-check-list').forEach(item => {
      item.addEventListener('blur', (event) => {
        this.displayModalTarget.classList.remove('visible')
      });
    })

    // もっと見る (Turbo Stream) で追加された行にも、その時点の表示設定を引き継ぐ
    this._onBeforeStreamRender = () => {
      requestAnimationFrame(() => {
        this.hiddenIndexes.forEach((index) => this.hideColumn(index));
      });
    };
    document.addEventListener('turbo:before-stream-render', this._onBeforeStreamRender);
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this._onBeforeStreamRender);
  }

  toggleDisplaySetting(event){
    // return if click on display items
    if (event.target.type == 'radio'){
      return
    }
    const classList = this.displayModalTarget.classList
    if (classList.contains('visible')){
      this.displayModalTarget.classList.remove('visible')
    }
    else {
      this.displayModalTarget.classList.add('visible')
    }
  }

  toggleTableColumn(event){
    const column = event.target.parentElement
    const index = this.getIndex(column)
    if (event.target.checked) {
      this.hiddenIndexes.delete(index);
      this.showColumn(index);
    } else {
      this.hiddenIndexes.add(index);
      this.hideColumn(index);
    }
  }

  hideColumn (index) {
    const cells = [].slice.call(this.table.querySelectorAll('th, td'));
    cells
      .filter( (cell) => {
        const cell_idx =  this.getIndex(cell)
        return cell_idx === index;
      })
      .forEach((cell) => {
        cell.style.display = 'none';
      });
  };

  showColumn(index) {
    const cells = [].slice.call(this.table.querySelectorAll('th, td'));
    cells
      .filter( (cell) => {
        return this.getIndex(cell) === index;
      })
      .forEach( (cell) => {
        cell.style.display = '';
      });
  };

  getIndex(el){
    return [...el.parentElement.children].indexOf(el);
  }
}
